import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme } from '../store/slices/uiSlice';

const ThemeToggle = ({ iconButtonSx }) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.ui.theme);

  const handleToggleTheme = () => {
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    dispatch(setTheme(newTheme));
    
    // Optionally save preference to localStorage
    localStorage.setItem('theme', newTheme);
  };

  return (
    <Tooltip title={`Switch to ${currentTheme === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton
        onClick={handleToggleTheme}
        color="inherit"
        aria-label="toggle theme"
        sx={iconButtonSx}
      >
        {currentTheme === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
      </IconButton>
    </Tooltip>
  );
};

ThemeToggle.propTypes = {
  iconButtonSx: PropTypes.object,
};

export default ThemeToggle;
